import Store from 'store/store'
import { writable } from 'utils/state'
import { Component } from 'utils/jsx'

import { save as saveStore } from 'store/file'

import APIServer from 'controllers/api-server'
import File from 'controllers/file'
import Export from 'controllers/export'
import showError from 'controllers/error'

import Button from 'components/dom/Button'
import Checkbox from 'components/dom/Checkbox'

export default class ExportScreen extends Component {
  beforeRender () {
    this.handleDownload = this.handleDownload.bind(this)
    this.update = this.update.bind(this)

    this.state = {
      isPending: writable(false)
    }
  }

  template () {
    return (
      <section class='export' store-class-is-pending={this.state.isPending}>
        <div class='export__container'>
          <ul class='export__items' ref={this.ref('content')} />
          <Button
            ref={this.ref('zip')}
            icon='arrow-down'
            class='export__button--download'
            store-disabled={this.state.isPending}
            event-click={this.handleDownload}
          >
            Télécharger
          </Button>
        </div>
        <Button
          icon='angle-left'
          class='export__button--close'
          event-click={() => Store.app.isExporting.set(false)}
        >
          revenir à l’édition
        </Button>
      </section>
    )
  }

  afterRender () {
    Store.app.isExporting.subscribe(this.update)
  }

  clear () {
    if (!this.refs.items) return
    this.refs.items.forEach(item => item.destroy())
    delete this.refs.items
  }

  update () {
    if (!Store.app.isExporting.get()) return

    this.clear()

    for (const [name, paper] of Store.papers.get()) {
      if (paper.state.hidden.get()) continue
      this.render((
        <ExportItem
          ref={this.refArray('items')}
          paper={paper}
          name={name}
          extension={paper.props.format.extension}
        />
      ), this.refs.content)
    }
  }

  async handleDownload () {
    if (this.state.isPending.get()) return
    this.state.isPending.set(true)

    const filename = Store.landscape.seed.get() + '.zip'
    const files = [
      await saveStore({ download: false })
    ]

    for (const item of this.refs.items) {
      if (!item.state.shouldDownload.get()) continue
      const data = await item.download()

      files.push({
        ...data,
        filename: item.state.filename
      })
    }

    File.save(filename, { blob: await File.zip(files) })
    APIServer.log('export', {
      filename,
      files: files.map(file => file.filename)
    })
    window.setTimeout(() => this.state.isPending.set(false), 1000)
  }
}

class ExportItem extends Component {
  beforeRender (props) {
    this.state = {
      data: undefined,
      shouldDownload: writable(true),
      isPending: writable(false),
      filename: props.name + '.' + props.extension
    }
  }

  template (props) {
    return (
      <li class='export-item' store-class-is-pending={this.state.isPending}>
        <Checkbox
          store-checked={this.state.shouldDownload}
          store-disabled={this.store.isPending}
        >
          {this.state.filename}
        </Checkbox>
      </li>
    )
  }

  async download () {
    try {
      this.state.isPending.set(true)

      // Download cached file in priority
      this.state.data = this.state.data || await Export[this.props.extension](this.props.paper)

      // timeout is used for cosmetic reasons
      window.setTimeout(() => {
        this.state.isPending.set(false)
      }, 100)

      return this.state.data
    } catch (error) {
      showError(error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/dom/Export.js